import {Injectable} from "@angular/core";
import {Storage} from "@ionic/storage";
import {TranslateService} from "@ngx-translate/core";
import * as moment from "moment";
import "moment/locale/da";

const storageKey = 'tolkify_app_locale';
const defaultLocale = 'da';

@Injectable()
export class LocaleService {

  constructor(
    private translate: TranslateService,
    private storage: Storage
  ){}

  getLocale() {
    return this.translate.currentLang;
  }

  setLocale(locale: string) {
    this.storage.ready().then(() => this.storage.set(storageKey, locale));
    this.translate.use(locale);
    moment.locale(locale);
  }

  init() {
    this.storage.ready()
      .then(() => this.storage.get(storageKey))
      .then((storedLocale) => {
        let locale = storedLocale || defaultLocale;
        this.translate.setDefaultLang(locale);

        this.translate.use(locale);
        moment.locale(locale);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/language-picker/locale.service.ts